import EventWrapper from './EventWrapper';

export default class MKEvent {
	constructor() {
		this.events = [];
	}

	add(action, context) {
		var eventWrapper = new EventWrapper(action, context);
		this.events.push(eventWrapper);
	}

	remove(action) {
		for (var i = 0; i < this.events.length; i++) {
			if (this.events[i].action == action) {
				this.events.splice(i, 1);
			}
		}
	}

	invoke() {
		this.events.forEach(eW => {
			if (eW != null && eW.action != null) eW.action.call(eW.context);
		});
	}
}
